import { useEffect, useState } from "react";
import { getRequest } from "helpers/utility/axiosServiceLayer";
import { composeApiURL } from "helpers/utility/axiosHelpers";
import { TargetDataset, toTargetDataset } from "./targetDataset";

const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;

/**
 * The dataset scan results are being added to, or null while it loads. Undefined
 * `datasetId` means the page is creating a new dataset, and nothing is fetched.
 */
export default function useTargetDataset(datasetId?: string) {
  const [target, setTarget] = useState<TargetDataset | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!datasetId) return;
    const controller = new AbortController();
    getRequest<Parameters<typeof toTargetDataset>[0]>(
      composeApiURL(HOST_URL, `/dataset/${datasetId}`),
      { signal: controller.signal },
    )
      .then((dataset) => setTarget(toTargetDataset(dataset)))
      .catch((e: any) => {
        if (e.name === "CanceledError" || e.code === "ERR_CANCELED") return;
        setError(e.response?.data?.detail || "Failed to load the dataset");
      });
    return () => controller.abort();
  }, [datasetId]);

  return { target, error };
}
